import { IShipmentStates } from 'types/graphqlTypes'

export const SHIPMENT_STATE_LABELS: Record<IShipmentStates, string> = {
  [IShipmentStates.alerted]: 'Alerted',
  [IShipmentStates.arrived_for_delivery]: 'At Delivery',
  [IShipmentStates.arrived_for_pickup]: 'At Pickup',
  [IShipmentStates.assigned]: 'Assigned',
  [IShipmentStates.canceled]: 'Canceled',
  [IShipmentStates.completed]: 'Completed',
  [IShipmentStates.covered]: 'Covered',
  [IShipmentStates.delivered]: 'Delivered',
  [IShipmentStates.dispatched]: 'Dispatched',
  [IShipmentStates.documents_received]: 'Document Received',
  [IShipmentStates.e_submitted]: 'E-Submitted',
  [IShipmentStates.in_transit]: 'In Transit',
  [IShipmentStates.invoice_sent]: 'Invoice Sent',
  [IShipmentStates.offered]: 'Offered',
  [IShipmentStates.on_hold]: 'On Hold',
  [IShipmentStates.pod_rejected]: 'POD Rejected',
  [IShipmentStates.quoted]: 'Quoted',
  [IShipmentStates.submitted]: 'Submitted',
  [IShipmentStates.tendered]: 'Tendered',
  [IShipmentStates.truck_ordered_not_used]: 'TONU',
  [IShipmentStates.waterfall_offered]: 'Reserved',
}

export type TShipmentStateLabels = typeof SHIPMENT_STATE_LABELS
